class TecliaTrixAttachment extends HTMLElement {
    connectedCallback() {
        if (this.isOn()) {
            this.render()
        }
    }

    render() {
        if (this.getAttribute('data-youtube-url')) {
            let url = this.getAttribute('data-youtube-url')
            this.innerHTML = `<iframe style="width: 100%; height: 300px;" src="${url}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`
        }
    }

    isOn() {
        let parent = this

        while (parent) {
            if (parent.getAttribute('data-teclia-trix-attachment') == 'on') {
                return true
            }

            parent = parent.parentElement
        }

        return false
    }
}

window.customElements.define('teclia-trix-attachment', TecliaTrixAttachment)
